import * as React from 'react'
import './index.scss'
import { ScheduleCardProps } from './types'
import { Icon } from '@petz/ds-icon'
import { Badge } from '@petz/ds-badge'
import { RedirectButton } from '../RedirectButton'

export const ScheduleCard: React.FC<ScheduleCardProps> = ({
  additionalDetailsUrl,
  date,
  locationName,
  paymentStatus,
  petAvatar,
  petName,
  schedulingType,
  time,
}: ScheduleCardProps) => {
  return (
    <div className="schedule-card-container" data-testid="schedule-card">
      <div className="schedule-card-header">
        <div className="pet-avatar-container">
          <img className="pet-avatar-image" alt={'Imagem de ' + petName} src={petAvatar} height={44} width={44} />
        </div>
        <p className="pet-name">{petName}</p>
        <div className="badge-container">
          <Badge text={schedulingType} brand={schedulingType == 'Veterinário' ? 'srs' : 'ptz'} />
        </div>
      </div>
      <div className="schedule-content-container">
        <div className="schedule-info">
          <Icon name="store" variant="line" size="md" />
          <p className="info-title">Loja</p>
          <p className="info-content">{locationName}</p>
        </div>
        <div className="schedule-info">
          <Icon name="schedule" variant="line" size="md" />
          <p className="info-title">Data</p>
          <p className="info-content">{date}</p>
        </div>
        <div className="schedule-info">
          <Icon name="clock-nine" variant="line" size="md" />
          <p className="info-title">Horário</p>
          <p className="info-content">{time}</p>
        </div>
        <div className="schedule-info">
          <Icon name="dollar-sign" variant="line" size="md" />
          <p className="info-title">Pagamento</p>
          <p className="info-content">{paymentStatus}</p>
        </div>
      </div>
      <div className="more-details-container">
        <RedirectButton title="Mais detalhes" kind="text" href={additionalDetailsUrl} section={'Consultar agendamentos'} subSection={'Consultar agendamentos'} />
      </div>
    </div>
  )
}
